<template>
  <v-card height="100%" :flat="flat">
    <v-card-title class="font-weight-black">{{ $t('delivery.product.products') }}</v-card-title>
    <v-card-text class="text-left">
      <!--RENDER ITEMS GROUP BY CATEGORY-->
      <order-items md="12" :items="order.items"></order-items>

      <cart-total
          :order="order"
      />
    </v-card-text>
  </v-card>

</template>

<script>
import OrderItems from "@/modules/delivery/components/OrderItems/OrderItems.vue";
import CartTotal from "@/modules/delivery/components-core/shared/CartTotal/CartTotal.vue";

export default {
  name: "ShowOrderItems",
  components: {CartTotal, OrderItems},
  props: {
    order: {type: Object},
    flat: {type: Boolean, default: false}
  },
  computed:{

  }
}
</script>

<style scoped>

</style>
